<template>
	<Icon v-bind="$props">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38">
			<!-- Font Awesome screwdriver-wrench (duotone) — both layers render together -->
			<path
				class="duotone"
				opacity="0.4"
				d="M4.58375 27.3778C2.91531 29.0463 2.91531 31.7538 4.58375 33.4222C6.25219 35.0906 8.95969 35.0906 10.6281 33.4222L16.2628 27.7816C14.8437 25.9231 14.3331 23.6075 14.7072 21.4166L12.6231 19.3325L4.58375 27.3778ZM17.4206 7.20219C17.8303 7.91469 18.0559 8.72219 18.0559 9.56531V11.3288L21.4284 14.7013C23.9578 14.2738 26.6594 15.0219 28.6187 16.9813L31.5341 19.8966C33.1847 18.1866 34.2059 15.865 34.2059 13.3C34.2059 12.1066 33.9862 10.9606 33.5825 9.90969C33.3569 9.31594 32.6028 9.20906 32.1516 9.65438L28.785 13.0209C28.6069 13.1991 28.3634 13.3 28.1141 13.3H25.6559C25.1334 13.3 24.7059 12.8725 24.7059 12.35V9.89188C24.7059 9.6425 24.8069 9.39906 24.985 9.22094L28.3516 5.85438C28.7969 5.40313 28.69 4.64906 28.0963 4.42344C27.0453 4.01969 25.8994 3.8 24.7059 3.8C21.7788 3.8 19.1662 5.12406 17.4206 7.20219Z"
			/>
			<path
				class="duotone"
				d="M7.30313 3.28344C6.92906 3.03406 6.42438 3.08156 6.10375 3.40219L3.40813 6.09781C3.0875 6.41844 3.04 6.91719 3.28938 7.29719L7.99188 14.3509C8.34219 14.8794 8.93594 15.1941 9.57125 15.1941H12.5163L17.9075 20.5853C17.0169 22.5625 17.3731 24.9672 19 26.5941L26.4931 34.0872C27.6034 35.1975 29.4084 35.1975 30.5247 34.0872L34.0931 30.5187C35.2034 29.4084 35.2034 27.6034 34.0931 26.4872L26.6059 19C24.9791 17.3731 22.5803 17.0169 20.5972 17.9075L15.2059 12.5162V9.57125C15.2059 8.93594 14.8913 8.34219 14.3569 7.99188L7.30313 3.28344Z"
			/>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ScrewdriverWrenchIcon',
	components: { Icon },
	props,
}
</script>
